import { Component, Injector, Input } from '@angular/core';
import { BaseFilterComponent } from 'app/core/filter-system';

@Component({
  selector: 'app-sidebar-category-filters',
  templateUrl: './sidebar-category-filters.component.html',
  styleUrls: ['./sidebar-category-filters.component.scss']
})
export class SidebarCategoryFiltersComponent extends BaseFilterComponent<number[]> {
  readonly filterId = 'benefit_category';

  @Input() categoryTree: any[];

  categorySelection: any[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  getQueryParamKey(): string {
    return 'benefit_category';
  }

  parseQueryParam(rawValue: string): void {
    this.categorySelection = [];
    rawValue.split(',').forEach(v => {
      this.categorySelection[v] = true;
    });
  }

  buildFilterValue(): number[] {
    // Parent-child cascading logic
    const bufferCategorySelection = {};

    for (let i = 0; i < this.categorySelection.length; i++) {
      if (this.categorySelection[i] !== undefined) {
        const category = this.categoryTree?.find(cat => cat.id === i);
        if (category?.children?.length > 0) {
          category.children.forEach(sc => {
            if (this.categorySelection[i]) {
              bufferCategorySelection[sc.id] = this.categorySelection[sc.id] === undefined ? true : this.categorySelection[sc.id];
            } else {
              bufferCategorySelection[sc.id] = false;
            }
          });
        }
      }
    }

    Object.keys(bufferCategorySelection).forEach(t => {
      this.categorySelection[t] = bufferCategorySelection[t];
    });

    const result: number[] = [];
    for (const key in this.categorySelection) {
      if (this.categorySelection[key]) {
        result.push(+key);
      }
    }
    return result;
  }

  clearSelection(): void {
    this.categorySelection = [];
  }

  checkCategory(): void {
    this.onFilterChange();
  }
}
